declare global {
  interface Window {
    safari: boolean;
    QuantumMetricAPI?: unknown;
  }
}

export const isSafari = window.safari !== undefined;
